import { createActions } from 'reduxsauce';

var _createActions = createActions({
  offlineOrdersRequest: function offlineOrdersRequest() {
    return {
      type: 'OFFLINE_ORDERS_REQUEST'
    };
  },
  offlineOrders: function offlineOrders(json) {
    return {
      type: 'OFFLINE_ORDERS',
      orders: json.orders
    };
  },
  offlineSearchRequest: function offlineSearchRequest() {
    return {
      type: 'OFFLINE_SEARCH_REQUEST'
    };
  },
  offlineSearchRetailProduct: function offlineSearchRetailProduct(json) {
    return {
      type: 'OFFLINE_SEARCH_RETAIL_PRODUCT',
      retailProducts: json.retailProducts
    };
  },
  offlineAddToCart: function offlineAddToCart(json) {
    return {
      type: 'OFFLINE_ADD_TO_CART',
      cart: json.cart
    };
  },
  closeAddTo: function closeAddTo() {
    return {
      type: 'CLOSE_ADD_TO'
    };
  },
  offlineCartRequest: function offlineCartRequest() {
    return {
      type: 'OFFLINE_CART_REQUEST'
    };
  },
  offlineCartResponse: function offlineCartResponse(json) {
    return {
      type: 'OFFLINE_CART_RESPONSE',
      cart: json.cart,
      price: json.price,
      isRetail: json.isRetail,
      destructuredCart: json.destructuredCart
    };
  },
  requestShippingModes: function requestShippingModes() {
    return {
      type: 'REQUEST_SHIPPING_MODES'
    };
  },
  recieveShippingModes: function recieveShippingModes(json) {
    return {
      type: 'RECIEVE_SHIPPING_MODES',
      shippingModes: json.data.shippingMethods
    };
  },
  setShippingMode: function setShippingMode(shippingMode) {
    console.log('Action: ', shippingMode);
    return {
      type: 'SET_SHIPPING_MODE',
      shippingMode: shippingMode
    };
  },
  patchItem: function patchItem() {
    return {
      type: 'PATCH_ITEM'
    };
  },
  clearRetailStates: function clearRetailStates() {
    return {
      type: 'CLEAR_RETAIL_STATES',
      retailProducts: []
    };
  },
  deleteFromCart: function deleteFromCart() {
    return {
      type: 'DELETE_FROM_CART'
    };
  },
  requestPostTip: function requestPostTip() {
    return {
      type: 'REQUEST_POST_TIP'
    };
  },
  recievePostTip: function recievePostTip() {
    return {
      type: 'RECIEVE_POST_TIP'
    };
  },
  recieveValidateCart: function recieveValidateCart() {
    return {
      type: 'RECIEVE_VALIDATE_CART'
    };
  },
  hideValidateCart: function hideValidateCart() {
    return {
      type: 'HIDE_VALIDATE_CART'
    };
  },
  requestSubmitCart: function requestSubmitCart() {
    return {
      type: 'REQUEST_SUBMIT_CART'
    };
  },
  recieveSubmitCart: function recieveSubmitCart(json) {
    return {
      type: 'RECIEVE_SUBMIT_CART',
      submitInfo: json.submitInfo,
      paymentInfo: json.paymentInfo
    };
  },
  resetLoading: function resetLoading() {
    return {
      type: 'RESET_LOADING'
    };
  },
  closeCheckout: function closeCheckout() {
    return {
      type: 'CLOSE_CHECKOUT'
    };
  },
  setGoToCheckout: function setGoToCheckout(json) {
    return {
      type: 'SET_GO_TO_CHECKOUT',
      goToCheckout: json.goToCheckout
    };
  },
  getCustomer: function getCustomer(json) {
    return {
      type: 'GET_CUSTOMER',
      custList: json.customerList.items
    };
  },
  assignCust: function assignCust(json) {
    return {
      type: 'ASSIGN_CUST',
      assigned: json.assigned
    };
  },
  resetCustList: function resetCustList() {
    return {
      type: 'RESET_CUST_LIST'
    };
  },
  setLoader: function setLoader() {
    return {
      type: 'SET_LOADER'
    };
  },
  setOfflineSelectedOrder: function setOfflineSelectedOrder(json) {
    return {
      type: 'SET_OFFLINE_SELECTED_ORDER',
      selectedOrder: json.selectedOrder
    };
  },
  requestPromoCode: function requestPromoCode() {
    return {
      type: 'REQUEST_PROMO_CODE'
    };
  },
  recievePromoCode: function recievePromoCode(code) {
    return {
      type: 'RECIEVE_PROMO_CODE',
      newCode: code
    };
  },
  removePromoCode: function removePromoCode(code) {
    return {
      type: 'REMOVE_PROMO_CODE',
      removeCode: code
    };
  }
}, {
  prefix: ''
}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};